import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { CatalogPage } from "@/features/catalog/components/catalog-page";

export const catalogRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/catalog",
  component: CatalogPage,
});
